module.exports = __webpack_public_path__ + "static/media/Chicago Defender _ 5-29-2015.a7ce3b51.png";